module.exports = __webpack_public_path__ + "static/media/shipping.6db4426b.jpg";